// removed by extract-text-webpack-plugin
module.exports = {"block":"user-menu__block-VdrYp","title":"user-menu__title-2vJpL","link":"user-menu__link-2ajk5","item":"user-menu__item-1TPiw","fadeLink":"user-menu__fadeLink-35Ifd","dropdown":"user-menu__dropdown-2guyY","isOpen":"user-menu__isOpen-2P7lV","dropdownAppearance":"user-menu__dropdownAppearance-mPYQQ","logout":"user-menu__logout-3DOG8","redirect":"user-menu__redirect-fIBwZ"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/header/user-menu/user-menu.css
// module id = 840
// module chunks = 0